"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  return {
    item: {
      cursor: "pointer",
      "& > div": {
        display: "block",
        height: "100%",
        width: "100%"
      }
    },
    download: {
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      position: "absolute",
      zIndex: 1
    }
  };
});
var _default = styles;
exports.default = _default;